import { CheckIcon, XMarkIcon } from '@heroicons/react/20/solid';
import Image from 'next/image';
import { Button } from '@/components/button';
import type { EnhancedPickemDto } from '@/components/pickems/types';
import { getTeamNames } from '@/utils/pickems';

interface PickedPickemProps {
  pickem: EnhancedPickemDto;
  onRemove: (pickemId: string) => void;
}

export const PickedPickem = ({ pickem, onRemove }: PickedPickemProps) => {
  const [team1Name, team2Name] = getTeamNames(
    pickem.match?.teamMatches ?? null
  );

  const selectedTeamName =
    pickem.selectedWinnerId === pickem.match?.teamMatches?.[0]?.teamId
      ? team1Name
      : team2Name;

  return (
    <div className="flex flex-col rounded-lg bg-[#1B2B3A]">
      <div className="flex items-center justify-between bg-[#0A1621] p-3">
        <div className="flex items-center gap-2 font-medium text-sm">
          <span className="text-gray">{team1Name ?? 'TBD'}</span>
          <span className="text-light-blue text-xs">VS</span>
          <span className="text-gray">{team2Name ?? 'TBD'}</span>
        </div>
        <Button
          aria-label={`Remove pick for ${team1Name} vs ${team2Name}`}
          onClick={() => onRemove(pickem.id ?? '')}
          size="sm"
          square
        >
          <XMarkIcon aria-hidden="true" className="h-4 w-4 text-gray-300" />
        </Button>
      </div>
      <div className="p-3">
        <div className="mb-4 flex items-center gap-2">
          {pickem.match?.league?.imageUrl && (
            <div className="shrink-0">
              <Image
                alt={pickem.match.league.name ?? 'League logo'}
                className="h-6 w-6 object-contain"
                height={24}
                src={pickem.match.league.imageUrl}
                width={24}
              />
            </div>
          )}
          <span className="text-white">{pickem.match?.league?.name}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray text-sm">Pick:</span>
          <div className="flex items-center gap-2">
            <CheckIcon className="h-4 w-4 text-green" />
            <span className="font-semibold text-white">{selectedTeamName}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
